import CRUDActions from '../CRUD';
import ShopStripe from '../../api/shop_stripe';

class StripeCrud extends CRUDActions {
  prefix = 'shop_stripe';

  get _model() {
    return ShopStripe;
  }

}

export const stripeActions = new StripeCrud();




// WEBPACK FOOTER //
// ./src/actions/shop/stripe.js